import {
  Autocomplete as AutocompleteComponent,
  AutocompleteTypes as AutocompleteComponentTypes,
  Stack,
  VStack,
} from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React, { useCallback } from 'react';

export declare namespace AutocompleteTypes {
  type SelectionProps = string | null;

  type SelectionChange = (
    selections: SelectionProps,
    fieldName: string,
    filterIndex: number
  ) => void;

  interface Props {
    type: 'autocomplete';
    fieldName: string;
    filterIndex: number;
    title: string;
    options: AutocompleteComponentTypes.AutocompleteOption[];
    onChange: SelectionChange;
    selection?: SelectionProps;
    customAutocompleteProps?: Partial<Pick<AutocompleteComponentTypes.Props, 'placeholder'>>;
  }
}

export const hasAutocompleteSelection = (selection: AutocompleteTypes.SelectionProps) =>
  !!selection;

export const Autocomplete: React.FC<AutocompleteTypes.Props> = ({
  title,
  options,
  fieldName,
  filterIndex,
  onChange,
  selection,
  customAutocompleteProps = {},
}) => {
  const handleChange = useCallback(
    (value: string) => {
      onChange(value, fieldName, filterIndex);
    },
    [fieldName, filterIndex, onChange]
  );

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} lineHeight="distant">
        {title}
      </Text>
      <Stack bgColor={Color.background} borderRadius={BoxBorder.thick}>
        <AutocompleteComponent
          testID="autocomplete-filter-options"
          options={options}
          placeholder="Selecione uma opção"
          onChange={handleChange}
          defaultValue={selection ?? undefined}
          {...customAutocompleteProps}
        />
      </Stack>
    </VStack>
  );
};
